//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'DocumentRow',
	props: {
		index: {
			type: Number,
			required: true
		},
		row: {
			type: Object,
			required: true
		},
		is_new: {
			type: Boolean,
			required: true
		},
		set_value: {
			type: Function,
			required: true
		},
	},
	data() {
		const data = {
			"show_reload_attachment": false,
		};

		return data;
	},
	computed: {
		calc_class_names() {
			return {
				'row': true,
				'form-section': true,
				'visible-section': true,
				'full-bleed': this.index % 2 !== 0,
			};
		},
		section_head() {
			const { row } = this;

			if (row.type) {
				return `${row.type} Attachment`;
			} else {
				return "New Attachment";
			}
		},
		document_display() {
			// const { row } = this;
			// const { document } = this.row;

			// if (document) {
			// 	const parts = document.split("/");
			// 	return parts[parts.length - 1];
			// } else {
			// 	return "";
			// }
			const { type } = this.row;
			if (type) {
				return `${type}`;
			} else {
				return "Attachment";
			}
		},
		document_link() {
			// const { row } = this;
			const { document } = this.row;

			if (document) {
				return document;
			} else {
				return "";
			}
		},
		attach_btn_label() {
			// const { row } = this;
			const { type } = this.row;

			if (type) {
				return `Upload ${type} Attachment`;
			} else {
				return "Upload Attachment";
			}

			// return "Attach File";
		},
		toggle_display_type() {
			// return window.outerWidth < 768;
			return {
				"col-sm-6": true,
				"form-column": true,
				"hide-on-mobile": this.show_reload_attachment,
			}
		},

	},
	methods: {
		handle_attachment_upload(event) {
			event.preventDefault();

			this.set_upload_options();
			this.file_uploader = new frappe.ui.FileUploader(this.upload_options);
		},
		handle_attachment_clear(event) {
			event.preventDefault();

			this.row.document = null;
			this.file_uploader = null;

			this.toggle_reload_button();
		},
		handle_delete_row() {
			this.$emit("delete-row", this.index);
		},

		set_upload_options() {
			let options = {
				allow_multiple: false,
				on_success: file => {
					this.on_upload_complete(file);
					this.toggle_reload_button();
				}
			};

			if (this.frm) {
				options.doctype = this.frm.doctype;
				options.docname = this.frm.docname;
				options.fieldname = this.df.fieldname;
			}

			// if (this.df.options) {
			// 	Object.assign(options, this.df.options);
			// }
			this.upload_options = options;
		},
		on_upload_complete: function (attachment) {
			this.row.document = attachment.file_url;
			console.log({ file_url: attachment.file_url });

			// this.set_value("document", attachment.file_url);
		},
		toggle_reload_button() {
			this.show_reload_attachment =
				this.file_uploader && this.file_uploader.uploader.files.length > 0;
		},
	},
}
